import React, { Component } from 'react';
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
} from '@js/components/Common/Modal';
import RatingStar from '../content/RatingStar';

class ModalComment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      star: 1,
      alreadyTypeWordsCount: 0,
      typeWords: '',
    };
  }

  /**
   * 評分 0-5星
   */
  changeStar = (star, editable) => {
    if (editable) {
      this.setState({ star });
    }
  };

  /**
   * 撰寫評論
   */
  changeAlreadyTypeWords = (e) => {
    const { length } = e.target.value;
    const typeWords = e.target.value;
    this.setState({
      alreadyTypeWordsCount: length,
      typeWords,
    });
  };

  /**
   * 送出評價信息
   */
  sendWriteReview = (e) => {
    const { postAddWriteReview, id } = this.props;
    const { star, typeWords } = this.state;

    e.preventDefault();
    e.stopPropagation();

    postAddWriteReview({
      sku: id,
      comment: typeWords,
      rating: star,
    });
    // 設回初始值
    this.setState({
      star: 1,
      alreadyTypeWordsCount: 0,
      typeWords: '',
    });
  };

  render() {
    const { isShow, handleModalShown, productName } = this.props;
    const { alreadyTypeWordsCount, star, typeWords } = this.state;
    return (
      <>
        <Modal id="comment-modal" isShow={isShow}>
          <ModalHeader handleModalShown={handleModalShown}>
            <div className="d-block text-center col-12 product__comment-modal-header-wrapper">
              <h3 className="product__comment-modal-title text-center">撰寫評價</h3>
              <p className="product__comment-product-name text-center">{productName}</p>
            </div>
          </ModalHeader>
          <ModalBody>
            <form>
              <h4 className="product__comment-form-label text-center">我要評分</h4>
              <div className="product__comment-rating-post mb-4">
                <RatingStar
                  editable
                  id="star"
                  name="star"
                  stars={star}
                  updateStar={this.changeStar}
                />
              </div>
              <h4 className="product__comment-form-label text-center">我的評論</h4>
              <textarea
                value={typeWords}
                name="review"
                id="review"
                className="product__comment-textarea form-control"
                placeholder="請輸入您對此商品的評價&#10;(限制字數為：50字)"
                maxLength={50}
                onChange={(e) => {
                  this.changeAlreadyTypeWords(e);
                }}
              />
              <div className="review__data">
                <p>
                  字數限制: 50, 您已輸入:
                  {alreadyTypeWordsCount}
                </p>
              </div>
            </form>
          </ModalBody>
          <ModalFooter>
            <div className="row col-8 justify-content-around mx-auto">
              <button
                type="button"
                className="btn btn-outline-third col-5"
                onClick={handleModalShown}
              >
                取消
              </button>
              <button
                type="button"
                className="btn btn-third btn__third col-5"
                onClick={(e) => {
                  handleModalShown(e);
                  this.sendWriteReview(e);
                }}
              >
                送出
              </button>
            </div>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export default ModalComment;
